import { render, staticRenderFns } from "./custom-company-productGroup.vue?vue&type=template&id=5ec6f251&scoped=true&"
import script from "./custom-company-productGroup.vue?vue&type=script&lang=js&"
export * from "./custom-company-productGroup.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-productGroup.vue?vue&type=style&index=0&id=5ec6f251&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec6f251",
  null
  
)

export default component.exports